import Button from './Button';
import styled from 'styled-components';
import {useConfig} from './ConfigProvider';
import "./Choice.scss";

export default function CounterChoiceCompact({value, selected, add, useImage=false, imageBaseURL}){
  const config = useConfig();

  let counterName = '';
  let price = '';
  let bullets = [];

  if (value.vel_datas) {
    counterName = value.vel_datas.name || '';
    price = value.vel_datas.sub1 || '';
    bullets = Array.from({ length: 10 }, (_, i) => value.vel_datas[`bullets_${i}`]).filter(e => e);
  }

  let count = 0;
  if (selected[value['@id']]) {
    count = selected[value['@id']].count;
  }

  const countStyle = {padding:'1rem'};
  if (count > 0) {
    countStyle.fontWeight= 'bold';
  }

  if (!useImage) {
    return;
  }

  const resamaniaImg = value.properties?.thumbnailImage?.publicId;
  const fallbackImg = '/empty.svg';

  const img = imageBaseURL && resamaniaImg
    ? `${imageBaseURL}${resamaniaImg}`
    : fallbackImg;

  return (
    <StyledArticle className="CompactOptionPreview" config={config.choice} selected={count > 0}>
      <div className="CompactOptionContent">
        <div className="CompactOptionContentImage" style={{backgroundImage: `url(${img})`}}></div>
        <div className="CompactOptionContentText">
          <header>
            <h3>{counterName}</h3>
            <strong>{price}</strong>
          </header>
          <section style={{display:'flex', flexGrow:1}}>
            {useImage !== 'only' && (
              <ul>
                {bullets.map((title, index) => (
                  <li key={index} style={{display:'flex', flexDirection:'row', alignItems:'center'}}>
                    <span style={{textAlign:'left'}}>{title}</span>
                  </li>
                ))}
              </ul>
            )}
          </section>
        </div>
      </div>
      <footer>
        <div style={{display:'flex', flexDirection:'row', justifyContent:'center', alignItems:'center'}}>
          <Button variant='textOnly' style={{padding:'1rem', fontSize:'2rem'}} onClick={e=> {e.preventDefault(); add(value, -1)}}>-</Button>
          <div className="optionCounter" style={countStyle}>{count}</div>
          <Button variant='textOnly' style={{padding:'1rem', fontSize:'2rem'}} onClick={e=> {e.preventDefault(); add(value, +1)}}>+</Button>
        </div>
      </footer>
    </StyledArticle>
  );
}


const StyledArticle = styled.article`
  background-color: ${props => props.config?.background || 'white'};
  border: ${props => props.selected
     ? `2px solid ${props.config?.border_selected || 'red'}`
     : `2px solid ${props.config?.border || 'green'}`
  };
  > header {
    h3 {
      color: ${props => props.config?.nameColor || '#e63f49' }
    }
  }
  > footer {
    background-color: ${props => props.selected
      ? (props.config?.footerBg || 'yellow')
      : (props.config?.footerBg_selected || 'red')};
  }

  input {
    background-color: ${props => props.selected ? (props.config?.checkboxSelected || 'black') : ''}
  }
`;
